module.exports = __webpack_public_path__ + "img/table-rotated.33b1ef6.webp";